import { actionTypeWrapper, errorLogger, updateAppAlert } from '@labrav/common'
import { camelize } from 'casing'
import {
  getApiErrorData,
  getApiErrorMessage,
} from '../../../utils/apiErrorResponse'
import type { AppDispatch, RootState } from '../../../store/types'
import { CloudMarketplace, FreeTierInfo, ProductsListingState } from '../types'
import { setFreeTierData, setSelectedProductOnListing } from '../actionCreators'

type ProductsResponseData = {
  free_tier_info?: {
    additional_allowed_products?: number
  }
  products?: {
    rows?: unknown[]
    page_number?: number
    page_size?: number
    total_count?: number
    has_next_page?: boolean
  }
}

export const clearSelectedProductIfNeeded = ({
  dispatch,
  getState,
  cloudMarketplace,
  preserveSelectedProduct = false,
}: {
  dispatch: AppDispatch
  getState: () => RootState
  cloudMarketplace: CloudMarketplace
  preserveSelectedProduct?: boolean
}) => {
  const shouldClearProductId =
    !preserveSelectedProduct &&
    getState().productsListing[cloudMarketplace]?.selectedProduct !== undefined

  if (!shouldClearProductId) {
    return
  }

  dispatch(
    actionTypeWrapper(cloudMarketplace, setSelectedProductOnListing(undefined))
  )
}

export const dispatchProductsAndFreeTier = ({
  dispatch,
  cloudMarketplace,
  data,
  setProductsAction,
}: {
  dispatch: AppDispatch
  cloudMarketplace: CloudMarketplace
  data: ProductsResponseData
  setProductsAction: (products: ProductsListingState) => {
    type: string
    payload: ProductsListingState
  }
}) => {
  const productsData = camelize(data) as ProductsListingState
  const freeTierData = camelize({
    additionalAllowedProducts:
      data?.free_tier_info?.additional_allowed_products,
  }) as FreeTierInfo

  dispatch(actionTypeWrapper(cloudMarketplace, setProductsAction(productsData)))
  dispatch(actionTypeWrapper(cloudMarketplace, setFreeTierData(freeTierData)))
}

export const dispatchProductListingError = ({
  dispatch,
  getState,
  error,
  defaultMessage,
}: {
  dispatch: AppDispatch
  getState: () => RootState
  error: unknown
  defaultMessage: string
}) => {
  const errorData = getApiErrorData(error)
  dispatch(
    updateAppAlert({
      message: getApiErrorMessage([defaultMessage], error),
      messageType: 'ERROR',
      autoClose: true,
    })
  )
  errorLogger({ globalState: getState() })(error as Error, errorData?.track_id)
}

export const dispatchProductListingSuccess = (
  dispatch: AppDispatch,
  message: string
) => {
  dispatch(
    updateAppAlert({
      message,
      messageType: 'SUCCESS',
      autoClose: true,
    })
  )
}
